import { Component, Input } from '@angular/core';

import { ContentUtil } from '../../utils/content/content.util';
import { RouterLink } from '@angular/router';
import { LinkModule } from '@vg-constellation/angular-20/link';
import { NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
    selector: 'zci-back-link',
    templateUrl: './back-link.component.html',
    imports: [
        NgSwitch,
        NgSwitchCase,
        RouterLink,
        LinkModule,
    ],
})
export class BackLinkComponent {
    content = ContentUtil.content;

    linkIconName = 'link-left';

    classNames = 'c11n-text-md';

    @Input() link: string;

    @Input() isExternal: boolean = false;
}
